import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { id: "header" }
const _hoisted_2 = { class: "header-container" }
const _hoisted_3 = { class: "left-container" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = {
  key: 0,
  class: "trial-days"
}
const _hoisted_6 = { class: "right-container" }
const _hoisted_7 = {
  key: 0,
  class: "nav-options"
}
const _hoisted_8 = { class: "nav-option login" }
const _hoisted_9 = { class: "nav-option signup" }
const _hoisted_10 = {
  key: 0,
  class: "nav-option subscribe"
}
const _hoisted_11 = { class: "nav-option login" }
const _hoisted_12 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "logo",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.goToLocation('/landing')))
        }, [
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "icon" }, null, -1)),
          _createElementVNode("div", _hoisted_4, [
            _createVNode($setup["LogoType"])
          ])
        ]),
        ($setup.daysLeftOnTrial)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString($setup.daysLeftOnTrial) + " day(s) on free trial", 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        ($setup.router.currentRoute.value.name !== 'Auth')
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (!$setup.auth.isAuthenticated)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("button", {
                        class: "secondary",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.routeToAuth('login')))
                      }, "Login")
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("button", {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.routeToAuth('signup')))
                      }, "Sign Up")
                    ])
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    ($setup.entitlements.userIsSubscribed && $setup.router.currentRoute.value.name !== 'Upload')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createElementVNode("button", {
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/upload')))
                          }, "Upload")
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("button", {
                        class: "empty",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push('/profile')))
                      }, [
                        _createElementVNode("img", { src: $setup.GearIcon }, null, 8, _hoisted_12)
                      ])
                    ])
                  ], 64))
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}